import React from "react";
import withInit from "WithInit";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { closeStaticSecondActionModal } from "StaticBuilderModals/actions";
import SecondActionModalV1 from "./SecondActionModalV1";

const SecondActionModal = (props) => <SecondActionModalV1 {...props} />;

SecondActionModal.propTypes = {
  closeStaticSecondActionModal: PropTypes.func.isRequired,
  isSecondActionModalOpen: PropTypes.bool.isRequired,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ closeStaticSecondActionModal }, dispatch);

const mapStateToProps = ({
  StaticBuilderModalHandler,
  StaticBuilderReducer,
}) => ({
  isSecondActionModalOpen: StaticBuilderModalHandler.isSecondActionModalOpen,
  fieldOutline: StaticBuilderReducer.fieldOutline,
});

export const SecondActionModalWithRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(SecondActionModal);

export default withInit(SecondActionModalWithRedux, true);



// WEBPACK FOOTER //
// ./src-react/StaticBuilderModals/SecondActionModal/index.jsx